<template>
    <div id="tests" :class="$root.isMob()? 'mob': ''" v-loading="loading">
        <div v-if="loading" class="loadingAlert">
            <el-alert
                title="加载中"
                description="正在加载数据,这可能需要一些时间,请稍后..."
                type="warning"
                center
                show-icon
                :closable="false">
            </el-alert>
        </div>
        <div class="title">
            <h2>
                <i class="el-icon-s-claim icon"></i>{{ title }}
            </h2>
            <div class="reload" @click="getList()">
                <i class="el-icon-refresh-right icon"></i>刷新
            </div>
        </div>
        <div class="list" v-if="type == 1">
            <div class="item" v-for="item in data" :key="item.id" @click="view(item)">
                <div class="content">
                    <div class="title">
                        <h3>{{ item.name }}</h3>
                    </div>
                    <div class="describe">
                        {{ item.describe }}
                    </div>
                    <div class="total">
                        <div v-if="item.starttime !== item.endtime">开放时间:{{ $root.formatDate(item.starttime) }} - {{ $root.formatDate(item.endtime) }}</div>
                        <div>共{{ item.tests_nums }}题</div>
                    </div>
                </div>
            </div>
            <el-empty v-if="data.length == 0" description="当前没有任何考试"></el-empty>
        </div>
        <div class="list" v-if="type == 2">
            <div class="item" style="height: 70px;" v-for="item in data" :key="item.id" @click="view(item)">
                <div class="content">
                    <div class="title">
                        <h3>{{ item.name }}</h3>
                    </div>
                    <div class="describe">
                        {{ item.remark }}&nbsp;
                    </div>
                    <div class="total">
                        <div>共31题</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page" v-if="data.length != 0">
            <el-pagination background layout="prev, pager, next" :page-count="lastPage"
                @current-change="changePage"></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: 'testsCenter',
    props: {
        title: {
            type: String,
            default: '试卷答题'
        },
        type: {
            type: Number,
            default: 1
        }
    },
    watch: {
        "currentPage"() {
            this.getList(this.currentPage);
        },
        "type"(){
            this.getList();
        }
    },
    data() {
        return {
            loading: true,
            API: window.config.api,
            lastPage: 1,
            currentPage: 1,
            data: [],
        }
    },
    methods: {
        async getList(page = 1) {
            this.loading = true;
            this.data = [];
            //考试题库
            if (this.type == 1) {
                let data = await this.$root.getTestsList(page);
                if (!data) {
                    return;
                }
                this.lastPage = data.data.last_page;
                this.data = data.data.data;
            }
            //练习题库
            if (this.type == 2) {
                let data = await this.$root.getCateList();
                if (!data) {
                    return;
                }
                this.data = data;
            }

            this.loading = false;
        },
        changePage(page) {
            this.currentPage = page;
        },
        view(item) {
            this.$emit('viewDetail', item.id, item.name,this.type);
        },
    },
    created() {
        this.getList();
    }
}
</script>
<style lang="scss" scoped src="@/assets/css/lib/tests.scss"></style>